<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { getPusherInstance } from '@/utils';

export default {
  name: 'ChatDataProvider',
  created() {
    this.loadChatData();
    getPusherInstance().bind('chat-change', () => this.loadChatData());

    // The backend announces every new chat on the shared event channel, so
    // only add chats this participant is a member of. Adding others' chats
    // let the first message of someone else's new conversation notify
    // every participant (until the next refresh dropped the chat again).
    getPusherInstance().bind('chat-new-chat', (data) => {
      const ownUser = this.$store.getters['Authentication/getUser'];
      const users = (data && data.item && data.item.Users) || [];
      if (ownUser && users.some((u) => u && u.UserID === ownUser.UserID)) {
        this.addChat(data);
      }
    });

    getPusherInstance().bind('chat-new-message', (data) =>
      this.addMessage(data)
    );

    getPusherInstance().bind('chat-new-user', (data) => this.addChatUser(data));
  },

  methods: {
    ...mapActions('Chat', ['loadChatData', 'resetChatPage', 'addMessage']),
    ...mapMutations('Chat', [
      'addChat',
      'updateChat',
      'deleteChat',
      'addChatUser',
      'updateChatUser',
      'deleteChatUser',
      'updateChatMessage',
      'deleteChatMessage'
    ])
  },
  computed: {
    ...mapGetters('Chat', ['getMode', 'getChats', 'isLoading'])
  },

  render() {
    if (this.isLoading) {
      return this.$scopedSlots.default({
        isLoading: this.isLoading
      });
    }

    return this.$scopedSlots.default({
      mode: this.getMode,
      chats: this.getChats
    });
  }
};
</script>
